import classNames from 'classnames'

import { FileList as FileListComponent } from '../../File'
import { FileListItem } from '../FileListItem'
import { getIsFileRemovable } from '../FilesContentGallery.utils'
import { FilesListUploadingItem } from '../FilesListUploadingItem'
import { FilesListUploadItem } from '../FilesListUploadItem'

import * as styles from './FilesList.module.css'

function FilesList({
  activeFile,
  className,
  fileClassName,
  files,
  uploadingFiles,
  uploadProps,
  onRemoveFile,
  onSelectFileListItem,
}) {
  function renderFile(file, key) {
    return file.uploading ? (
      <FilesListUploadingItem file={file} key={key} />
    ) : (
      <FileListItem
        active={activeFile && file.id === activeFile.id}
        className={fileClassName}
        file={file}
        key={key}
        onClick={onSelectFileListItem}
        onRemove={
          onRemoveFile && getIsFileRemovable(file) ? onRemoveFile : undefined
        }
      />
    )
  }

  return (
    <div className={classNames(styles.container, className)}>
      <FileListComponent
        className={styles.list}
        files={files}
        itemClassName={styles.item}
        renderItem={renderFile}
        uploadingItems={uploadingFiles}
      >
        {uploadProps ? <FilesListUploadItem {...uploadProps} /> : null}
      </FileListComponent>
    </div>
  )
}

export default FilesList
